module.exports = __webpack_public_path__ + "static/sustainaCar-4abfa97c32ad1e3a8d0e8d0db4a17b7b.jpg";